module.exports = __webpack_public_path__ + "img/bag-dash.f1ed612c.svg";